import { ClubFBItem } from './../../../model/ClubFBItem';
import { Button, Container, Stack, Title, Text, useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';

function AdditonalSettings({ data }: { data: ClubFBItem }) {

    const theme = useMantineTheme();
    const { t } = useTranslation();

    const handleButtonClick = (url: string) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <Container size="xs" style={{ textAlign: 'center', paddingTop: '2rem' }}>
            <Title order={2} style={{ marginBottom: '1rem' }}>{t('settings.title')}</Title>
            <Text color="dimmed" style={{ marginBottom: '2rem' }}>
                {t('settings.subtitle')}
            </Text>
            <Stack align="center">
                <Button
                    onClick={() => handleButtonClick('https://nature-golf-app.com/impressum')}
                    variant="outline"
                    fullWidth
                >
                    {t('settings.imprint')}
                </Button>
                <Button
                    onClick={() => handleButtonClick('https://sunbird.tv/privacy')}
                    variant="outline"
                    fullWidth
                >
                    {t('settings.privacy')}
                </Button>
            </Stack>
        </Container>
    );
}

export default AdditonalSettings;
